<template>
  <div>
    <CRow>
      <CCol xs="12" lg="10">
        <CCard>
          <CCardHeader>
            <strong>Πελάτης τιμολογίου:</strong> {{ title }}
          </CCardHeader>
          <CCardBody>
            <CDataTable 
              striped 
              small 
              fixed
              :items="items" 
              :fields="fields"
            >
              <template slot="value" slot-scope="data">
                <td><strong>{{data.item.value}}</strong></td>
              </template>
            </CDataTable>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </diV>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'InvoiceClient',
  data: () => {
    return {
      items: [],
      title: '',
      fields: [
        { 
          key: 'key',
        },
        {
          key: 'value',
        },
      ],
    }
  },
  methods: {
    getinvoiceClientData (id) {
      const invoiceClient = invoiceClientsData.find((invoiceClient, index) => index + 1 == id)
      const invoiceClientDetails = invoiceClient ? Object.entries(invoiceClient) : [['id', 'Not found']]
      return invoiceClientDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    },
    getInvoiceClient() {
      let self = this;
      axios.get('/api/invoiceclients/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        const ser_items = Object.entries(response.data.invoiceclient).map(([key, value]) => {return {key: key, value: value}});
        const keys = ["id", "client_code", "name", "address", "phone_number_1", "company", "afm", "town", "state", "postcode", "doy"];
        self.items = ser_items.filter((t) => keys.includes(t.key));
        self.title = self.items.find((t) => t.key == "company").value;

        const items = Object.entries(response.data.invoiceclient);
        self.items = items.map(([key, value]) => {return {key: key, value: value}});

        self.items = self.items.map((item) => {
          if (item.key == "id") {
              item.key = "ID:";
          } else if (item.key == "client_code") {
              item.key = "Κωδικός:";
          } else if (item.key == "created_at") {
              item.value = moment(new Date(item.value)).format('DD-MM-YYYY');
              item.key = "Καταχωρήθηκε στις:";
          } else if (item.key == "updated_at") {
              item.value = moment(new Date(item.value)).format('DD-MM-YYYY');
              item.key = "Ενημερώθηκε στις:";
          } else if (item.key == "name") {
              item.key = "Υπεύθυνος Επικοινωνίας:";
          } else if (item.key == "afm") {
              item.key = "ΑΦΜ:";
          } else if (item.key == "address") {
              item.key = "Διεύθυνση:";
          } else if (item.key == "company") {
              item.key = "Επωνυμία Εταιρίας:";
          } else if (item.key == "phone_number_1") {
              item.key = "Τηλέφωνο:";
          } else if (item.key == "town") {
            item.key = "Πόλη:";
          } else if (item.key == "state") {
            item.key = "Νομός:";
          } else if (item.key == "postcode") {
            item.key = "Ταχυδρομικός Κώδικας:";
          } else if (item.key == "doy") {
            item.key = "ΔΟΥ:";
          } 

          return item;
        });
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      }); 
    }
  },
  mounted: function(){
    let self = this;
    self.getInvoiceClient();
  }
}

</script>
